









































import 'reflect-metadata'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { convertToCurrency, toDCM } from '@/helper'
import VueApexChartsComponent from 'vue-apexcharts'

@Component({
    components: { VueApexChartsComponent },
    filters: { toDCM },
})
export default class Supply extends Vue {
    series: number[] = []
    fillcolor = ''
    trackColor = ''
    valueColor = ''
    get theme() {
        const data = (this as any).$root.theme
        this.fillcolor = data === 'night' ? '#BBF45C' : '#558cf2'
        this.trackColor = data === 'night' ? '#0f014680' : '#9fedf8'
        this.valueColor = data === 'night' ? '#fff' : '#9D43F7'
        return data
    }
    chartOptions = {}
    mounted() {
        this.drawGraph()
    }

    @Watch('theme')
    drawGraph() {
        this.chartOptions = {
            chart: {
                height: 200,
                type: 'radialBar',
                foreColor: '#fff',
            },
            plotOptions: {
                radialBar: {
                    startAngle: -120,
                    endAngle: 240,
                    hollow: {
                        size: '50%',
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            fontSize: '20px',
                            offsetY: 10,
                            fontWeight: 600,
                            color: this.valueColor,
                        },
                    },
                    track: {
                        background: this.trackColor,
                    },
                },
            },
            labels: ['Circulating Supply'],
            fill: {
                colors: [this.fillcolor],
            },
            tooltip: {
                enabled: true,
            },
            title: {
                text: 'Total Supply', // Add your desired title text
                align: 'center',
                offsetY: 180,
                style: {
                    color: '#fff',
                    fontSize: '12px', // Adjust font size as needed
                    opacity: 0.5,
                },
            },
        }
    }
    get currentSupply() {
        return this.$root.$store.state.Metrics.currentSupply
    }

    get inDCM() {
        this.series = [
            parseFloat(
                (
                    (toDCM(this.currentSupply?.supply || '0') / 720000000) *
                    100
                ).toFixed(2)
            ),
        ]
        return toDCM(this.currentSupply?.supply || '0')
    }
    get convertedAmt() {
        if (this.currentSupply) {
            return toDCM(this.currentSupply?.supply || '0')
        } else return 0
    }
    convertNum(num: number) {
        if (num > 999 && num < 1000000) {
            return (num / 1000).toFixed(1) + 'K'
        } else if (num > 1000000) {
            return (num / 1000000).toFixed(1) + 'M'
        } else if (num < 900) {
            return num
        }
    }
}
